import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import {
  ADMIN_AFFILIATE_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION_MAIN_ROUTE_NAME,
  AFFILIATE_SUBAFFILIATE_SETTINGS,
} from '@modules/affiliates-approved/submodules/trackers-settings/submodules/subaffiliate-condition/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  SUBAFFILIATE_HISTORY_CHANGES_EDIT_ROUTE_NAME,
  TRANSLATION_GROUP_SUBAFFILIATE_HISTORY_CHANGES_EDIT,
} from './constants';
import { getTranslationKeys } from './translations';

export class AffiliatesApprovedSubaffiliateConditionHistoryChangesEditModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_AFFILIATE_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION_MAIN_ROUTE_NAME, {
      name: SUBAFFILIATE_HISTORY_CHANGES_EDIT_ROUTE_NAME,
      path: ':merchantId/history/:itemId',
      component: () => import('./pages/SubaffiliateHistoryChangesEditPage/SubaffiliateHistoryChangesEditPage.vue'),
      permission: AFFILIATE_SUBAFFILIATE_SETTINGS.HISTORY_CHANGES_EDIT,
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_SUBAFFILIATE_HISTORY_CHANGES_EDIT, getTranslationKeys);
  }
}
